export class Permissions {
    static KioskSetup = "KioskSetup";
    static CashCollection = "CashCollection";
}
